export const Wave = (props?: any) => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        {...props}
    >
        <path
            d="M0,64L80,90.7C160,117,320,171,480,165.3C640,160,800,96,960,74.7C1120,53,1280,75,1360,85.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        />
    </svg>
}